<template>
  <b-modal @ok="ok" @cancel="e => $emit('cancel', e)" @show="$nextTick(() => show())" :id="id"
    :title="$t(title || id || '입력폼')" :lazy="lazy" :ok-only="viewMode" :modal-class="modalClass" :body-class="bodyClass" :size="size"
    :ok-title="$t(viewMode ? '확인' : okTitle || id)" :cancel-title="$t(cancelTitle || '닫기')"
    :hide-footer="hideFooter" :no-close-on-backdrop="!viewMode && !closeOnBackdrop" scrollable centered>
    <div class="modal-form">
      <slot />
      <template
        v-for="({ title, label, slot, key, type, readonly, prepend, append, options, required, requiredIcon, min, max, placeholder, maxlength }, i) in fspec">
        <SignStamp v-b-tooltip="title" ref="stamp" :key="i" v-if="['sign', 'stamp'].includes(type)" :type="type"
          :currentType="form.stampType"
          @save="({ blob, name }) => { form[key] = blob; blobNms[key] = name }" />
        <div v-b-tooltip="title" :key="i" v-else-if="type == 'file'" class="dropzone">
          <div>
            <div :class="{ 'required': required || requiredIcon }">{{
              form[key] ? form[key].name : $t(label)
            }}</div><small>(Click or Drag & Drop)</small>
          </div>
          <input type="file" :accept="fspec[i].accept" @change="e => { form[key] = e.target.files[0]; $forceUpdate() }" />
        </div>
        <b-form-group v-b-tooltip="$t(title)" v-else :key="i" :label="$t(label)" :label-class="!viewMode && (required || requiredIcon) ? 'required' : ''"
          label-align="end" :label-cols="labelCols">
          <slot v-if="slot" :name="slot" />
          <b-form-tags style="margin:5px 0" :class="{'v-mode':viewMode}" v-else-if="type == 'tag'" :maxlength="maxlength||100" :add-on-change="!!options" :placeholder="placeholder"
            :disabled="!!(viewMode || (readonly || []).includes(id))" v-model="form[key]" :required="required">
            <template v-if="options" v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag @remove="removeTag(tag)" :disabled="disabled">{{ tag
                  }}</b-form-tag>
                </li>
              </ul>
              <b-form-select v-bind="inputAttrs" v-on="inputHandlers"
                :disabled="disabled || !options.find(o => !form[key].includes(o))"
                :options="options.filter(o => !form[key].includes(o))">
                <template #first>
                  <option disabled value="" v-text="$t('추가 대상을 선택하세요')" />
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
          <template v-else-if="options">
            <div class="v-mode" v-if="viewMode || (readonly || []).includes(id) || type == 'disabled'"
              v-text="options[0] && options[0].text ? (options.find(o => o.value == form[key]) || {}).text : form[key]" />
            <b-form-radio-group v-else-if="type == 'radio'" v-model="form[key]" :options="options" :required="required"
              plain />
            <b-form-select v-else v-model="form[key]" :options="options" :required="required" />
          </template>
          <b-form-checkbox switch v-else-if="type == 'switch'" v-model="form[key]"
            :readonly="viewMode || (readonly || []).includes(id)" />
          <b-form-checkbox switch v-else-if="type == 'switch-yn'" :checked="form[key] == 'Y'"
            @change="form[key] = $event ? 'Y' : 'N'" :readonly="viewMode || (readonly || []).includes(id)" />
          <b-input-group v-else-if="type == 'date-between' && form[key]">
            <b-form-input min="1000-01-01" max="9999-12-31" type="date" v-model="form[key][0]"
              onfocus="this.showPicker()" />
            <span style="padding: 9px 5px 0">~</span>
            <b-form-input min="1000-01-01" max="9999-12-31" type="date" v-model="form[key][1]"
              onfocus="this.showPicker()" />
          </b-input-group>
          <b-input-group v-else-if="type == 'number-between' && form[key]">
            <b-form-input :maxlength="maxlength||100" type="number" v-model="form[key][0]" />
            <span style="padding: 9px 5px 0">~</span>
            <b-form-input :maxlength="maxlength||100" type="number" v-model="form[key][1]" />
          </b-input-group>
          <b-form-textarea :maxlength="maxlength||2000" v-else-if="!viewMode && type == 'textarea'" :placeholder="placeholder" v-model="form[key]"
            :required="required" />
          <div class="v-mode" v-else-if="viewMode"
            v-text="`${prepend ? prepend + ' ' : ''}${form[key] == undefined ? '' : form[key]}${append ? ' ' + append : ''}`" />
          <b-input-group v-else :prepend="prepend" :append="append"><b-form-input :maxlength="maxlength||100" v-model="form[key]"
              :min="min || ((type + '').indexOf('date') == 0 && '1000-01-01') || ''"
              :max="max || ((type + '').indexOf('date') == 0 && '9999-12-31') || ''"
              :autocomplete="type == 'password' ? 'new-password' : undefined" :type="type == 'textarea' ? 'text' : type"
              :readonly="viewMode || (readonly || []).includes(id)" :required="required" :placeholder="placeholder"
              onfocus="if(!this.readOnly)this.showPicker()" /></b-input-group>
        </b-form-group>
      </template>
      <slot name="bottom" />
    </div>
  </b-modal>
</template>

<script>
import SignStamp from "@/components/SignStamp.vue";

export default {
  components: { SignStamp },
  props: {
    id: {},// 모달 id
    title: {},// 모달창 title
    size: {},// 모달창 size
    modalClass: {},// 모달창 class
    bodyClass: {},// 모달창 Body class
    okTitle: { default: () => '확인' },// ok 버튼 title
    cancelTitle: { default: () => '취소' },// cancel 버튼 title
    labelCols: { default: 4 },// 라벨폭 (12분할)
    spec: { default: () => [] },// 컬럼 스펙
    data: {},// 입력폼에 할당할 데이터
    hideFooter: Boolean, okOnly: Boolean, formOnly: Boolean, closeOnBackdrop: Boolean, noCloseOnOk: Boolean, lazy: Boolean, changedOnly: Boolean,
  },
  computed: {
    viewMode() { return this.id == 'view' || this.okOnly },
    fspec() { return this.spec.filter(s => (this.formOnly || this.id == 'view' && s.key || s.form) && !(s.hide || []).includes(this.id)).sort((a, b) => (a.form || 100) - (b.form || 100)) },
  },
  data: () => ({
    form: {},// 입력폼들의 value (원본을 수정하지 않도록 data에서 복제하여 사용)
    blobNms: {},//키별블롭네임 임시저장
  }),
  watch: { data: 'show' },
  methods: {
    /** ok 버튼 클릭시 실행 */
    async ok(evt) {
      if (this.viewMode) return;
      if (this.$refs.stamp) {
        evt.preventDefault();
        for (const s of [this.$refs.stamp].flat()) await s.save();
      }
      else if (this.noCloseOnOk) evt.preventDefault();
      for (const s of this.fspec) if (s.validate && s.validate(this.form)) {
        evt.preventDefault();
        return this.$alert(this.$t(s.validate(this.form)));
      }
      let form = this.$formSendMaper(this.form, this.fspec);
      if (this.data && this.changedOnly)
        for (const key in form) if (form[key] === this.data[key]) delete form[key];
      if (this.fspec.find(s => ['file', 'sign', 'stamp'].includes(s.type))) {
        const formData = new FormData();
        formData.headers = { 'Content-Type': 'multipart/form-data' };
        for (const key in form)
          if (form[key] == undefined);
          else if (this.blobNms[key]) formData.append(key, form[key], this.blobNms[key]);
          else formData.append(key, form[key]);
        form = formData;
        this.$bvModal.hide(this.id);
      }
      this.$emit('action', { action: this.id, form, evt });
    },
    /** 모달창 보여질때 실행 */
    show() {
      this.form = {};
      for (const s of this.fspec) {
        const value = !this.data
          ? this.getDefault(s)
          : this.data[s.key] != undefined
            ? (this.data[s.key].f ? this.data[s.key].f(s.type, s.mask) : this.data[s.key])
            : s.type == 'tag'
              ? []
              : this.getDefault(s);

        this.$set(this.form, s.key, value);

        if (s.required && !s.validate) {
          s.validate = form => (
            !form[s.key] ||
            (form[s.key].trim && !form[s.key].trim())
          ) && s.label + ' 항목을 입력하세요';
        }
      }
      this.$emit('show', this);
    },
    getDefault(spec) {
      return spec.default===undefined ? undefined : typeof spec.default === 'function' ? spec.default(this) : spec.default;
    },
  },
}
</script>
